import {
  Component,
  EventEmitter,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { SettingsDTO } from '../../common/types/settings';
import { Subscription } from 'rxjs';
import { formatDateToHHmm } from '../../common/utils';

@Component({
  selector: 'app-opening-hours',
  templateUrl: './opening-hours.component.html',
  styleUrl: './opening-hours.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class OpeningHoursComponent implements OnInit, OnChanges, OnDestroy {
  @Input() settings: SettingsDTO;
  @Output() tabChangedEvent = new EventEmitter();

  openingHoursForm: FormGroup;
  private formSub: Subscription;

  constructor(private formBuilder: FormBuilder) {
    this.openingHoursForm = formBuilder.group({
      openTime: [null],
      closeTime: [null],
      closeIsOnSameDay: [true]
    })
  }

  ngOnInit() {
    this.formSub = this.openingHoursForm.valueChanges.subscribe(value => {
      const formValue = {
        ...value,
        openTime: value.openTime instanceof Date ? formatDateToHHmm(value.openTime) : value.openTime,
        closeTime: value.closeTime instanceof Date ? formatDateToHHmm(value.closeTime) : value.closeTime
      };
      this.tabChangedEvent.emit(formValue);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['settings'] && changes['settings'].currentValue) {
      this.openingHoursForm.patchValue(changes['settings'].currentValue, { emitEvent: false });
    }
  }

  ngOnDestroy() {
    if (this.formSub) {
      this.formSub.unsubscribe();
    }
  }
}
